<template>
    <div class="cms-container mb-4">
        <ToastCMS ref="toast" />
        <!-- PREVIEW IMAGE -->
        <div v-if="showPreviewModal" class="preview-modal w-100 h-100 d-flex align-items-center justify-content-center"
            @click.self="closePreviewImage">
            <div class="d-block-align-items-center justify-content-center w-100 mx-3">
                <div class="modal-content bg-transparent position-relative border-0">
                    <button class="close-btn position-fixed text-white bg-transparent border-0"
                        @click="closePreviewImage">&times;</button>

                    <div class="d-flex justify-content-between align-items-center border-0">
                        <img :src="previewImages[currentPreviewIndex]" alt="Preview Image">
                    </div>
                </div>

                <div v-if="previewImages.length > 1" class="text-center mt-3">
                    <span class="text-white">Image {{ currentPreviewIndex + 1 }} of {{ previewImages.length }}</span>
                </div>
            </div>
        </div>
        <div class="sticky-controls">
            <div class="main-header d-flex align-items-center justify-content-between mb-3 px-3">
                <div class="principals-header text-dark">Our Principals</div>
                <button type="button" class="vmc-bg-prime-4 border-0 rounded px-2 py-1 text-white"
                    @click="addContainer">
                    Add Item
                </button>
            </div>
        </div>
        <form action="" id="principals" @submit.prevent="saveAllChanges">
            <div class="pb-3">
                <div class="grid-header">
                    <div class="w-100 mb-4" v-for="(container, index) in containers" :key="index">
                        <div class="d-flex px-3 align-items-center justify-content-between w-100 mt-2">
                            <span class="content-header text-dark">
                                Company # {{ index + 1 }}
                            </span>
                            <button type="button" class="vmc-bg-prime-6 text-white border-0 rounded px-2 py-1"
                                @click="removeContainer(index)">
                                Remove
                            </button>
                        </div>
                        <div class="input-group mt-3 px-3">
                            <input type="text" class="input-field w-100 text-dark p-2" placeholder=""
                                v-model="container.name">
                            <label class="floating-label mx-3">Company Name</label>
                        </div>
                        <div class="input d-block d-sm-flex px-3">
                            <div class="input-group mt-4">
                                <input type="text" class="input-field w-100 text-dark p-2" placeholder=""
                                    v-model="container.address">
                                <label class="floating-label">Address</label>
                            </div>
                            <div class="input-group mt-4">
                                <input type="text" class="input-field w-100 text-dark p-2" placeholder=""
                                    v-model="container.tel">
                                <label class="floating-label">Contact No.</label>
                            </div>
                            <div class="input-group mt-4">
                                <input type="text" class="input-field w-100 text-dark p-2" placeholder=""
                                    v-model="container.fax">
                                <label class="floating-label">Contact Fax</label>
                            </div>
                        </div>
                        <div class="input d-block d-sm-flex px-3">
                            <div class="w-100 mt-3">
                                <label class="text-dark">Company Description</label>
                                <textarea rows="3" class="text-dark w-100" v-model="container.content"></textarea>
                            </div>
                        </div>
                        <div class="mt-3 px-3">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <span class="text-dark">Description Image</span>
                                <button type="button" @click="previewImage(index)"
                                    class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                    View
                                </button>
                            </div>
                            <div
                                style="height:200px; width:100%; background-position:center; border:1px solid gray; margin-bottom:10px; display:flex; justify-content:center; align-items:center; overflow:hidden;">

                                <img v-if="container.logo" :src="container.logo" alt="Slide Image"
                                    style="height:100%; width:100%; object-fit:contain;">

                                <template v-else>
                                    <input type="file" :id="'upload-principals-img-' + index"
                                        accept="image/png, image/jpeg, image/jpg" hidden
                                        @change="onImageChange($event, index)">

                                    <label :for="'upload-principals-img-' + index"
                                        class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                                        style="cursor:pointer;">
                                        <i class="material-symbols-outlined">upload</i>
                                        <span>Upload Photo</span>
                                    </label>
                                </template>
                            </div>
                            <button @click="resetImage(index)" type="button"
                                class="vmc-bg-prime-6 w-100 text-white rounded px-2 py-1 border-0">
                                Remove Photo
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="px-3">
            <button type="submit" form="principals" class="vmc-bg-prime-4 px-3 py-1 border-0 text-white rounded">
                Save All Changes
            </button>
        </div>
    </div>
</template>

<script>
import ToastCMS from '../ToastCMS.vue';
export default {
    name: "OurPrincipalsCMS",
    components: {
        ToastCMS
    },
    data() {
        return {
            /* Each item: { name, address, tel, fax, content, logo } — matches backend principalsList shape */
            containers: [],
            originalContainers: [],
            previewImages: [],
            showPreviewModal: false,
            currentPreviewIndex: 0
        }
    },
    methods: {
        addContainer() {
            this.containers.push({
                name: '',
                address: '',
                tel: '',
                fax: '',
                content: '',
                logo: ''
            });
            this.$refs.toast.showToast(`Company # ${this.containers.length} added`, "success");
        },

        removeContainer(index) {
            this.containers.splice(index, 1);
            this.$refs.toast.showToast(`Company # ${index + 1} removed`, "error");
        },

        async onImageChange(e, index) {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch('/vmc/api/upload', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
                },
                body: formData
            });

            const data = await response.json();

            if (response.ok) {
                this.$set(this.containers[index], 'logo', data.url);
                this.$refs.toast.showToast(`Image # ${index + 1} attached`, "success");
            } else {
                console.error("Upload failed:", data.message);
            }
        } catch (error) {
            console.error("Upload error:", error);
        }
    }
    e.target.value = "";
},

        resetImage(index) {
            if (!this.containers[index].logo) {
                this.$refs.toast.showToast(`No image attached`, "warning");
                return;
            }
            this.$set(this.containers[index], 'logo', '');
            const input = document.getElementById(`upload-principals-img-${index}`);
            if (input) input.value = "";
            this.$refs.toast.showToast(`Image # ${index + 1} removed`, "error");
        },

        previewImage(index) {
            if (!this.containers[index].logo) {
                this.$refs.toast.showToast("No images to view", "warning");
                return;
            }
            this.previewImages = [this.containers[index].logo];
            this.currentPreviewIndex = 0;
            this.showPreviewModal = true;
        },

        closePreviewImage() {
            this.showPreviewModal = false;
            this.previewImages = [];
        },

        async loadFormData() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content?_nocache=${new Date().getTime()}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) throw new Error("Failed to fetch content");

                const data = await response.json();

                if (data && Array.isArray(data.principalsList)) {
                    this.containers = data.principalsList.map(p => ({
                        name: p.name || '',
                        address: p.address || '',
                        tel: p.tel || '',
                        fax: p.fax || '',
                        content: p.content || '',
                        logo: p.logo || ''
                    }));
                    this.originalContainers = JSON.parse(JSON.stringify(this.containers));
                }

            } catch (error) {
                console.error("Load error:", error);
                this.$refs.toast.showToast("Failed to load data!", "error");
            }
        },

        async saveAllChanges(e) {
            e.preventDefault();

            if (!this.hasChanges) {
                this.$refs.toast.showToast("Nothing to save", "warning");
                return;
            }

            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        principalsList: this.containers
                    })
                });

                if (!response.ok) throw new Error("Server error");

                this.originalContainers = JSON.parse(JSON.stringify(this.containers));

                this.$refs.toast.showToast("Saved all changes.", "success");
                setTimeout(() => { window.location.reload(); }, 1500);

            } catch (error) {
                console.error("Save error:", error);
                this.$refs.toast.showToast("Save failed. Check your connection.", "error");
            }
        }
    },

    async mounted() {
        await this.loadFormData();
    },

    computed: {
        hasChanges() {
            return JSON.stringify(this.containers) !== JSON.stringify(this.originalContainers);
        }
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    width: 300px;
    top: 20px;
    right: 20px;
    z-index: 9999;
}

hr {
    border-top: 1px solid black;
}

.sticky-controls {
    position: sticky;
    z-index: 1;
    background-color: white;
}

@media (min-width: 330px) {
    .main-header {
        padding: 15px 0;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .principals-header {
        font-size: 17px;
        font-weight: 600;
    }

    .content-header {
        font-size: 18px;
        font-weight: 600;
    }

    .grid-header>div {
        width: 100%;
    }

    .input {
        gap: 10px;
    }

    textarea {
        resize: none;
    }

    input,
    textarea {
        font-size: 15px;
        outline: none;
    }

    button {
        font-size: 16px;
    }

    input {
        height: 36px;
    }

    .input-group {
        position: relative;
        display: flex;
    }

    .input-field {
        border: 1px solid gray;
        border-radius: 4px !important;
        width: 100%;
        outline: none;
    }

    .floating-label {
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translateY(-50%);
        color: gray;
        background-color: white;
        transition: all 0.3s ease;
        pointer-events: none;
    }

    .input-field:focus~.floating-label,
    .input-field:not(:placeholder-shown)~.floating-label {
        top: 0;
        left: 8px;
        transform: translateY(-50%);
        font-size: 12px;
    }

    .preview-modal {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        overflow-y: hidden;
        overscroll-behavior: contain;
    }

    .modal-content img {
        max-width: 70vw;
        max-height: 70vh;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
        margin: 0 auto;
    }

    .close-btn {
        top: 10px;
        right: 15px;
        font-size: 24px;
        cursor: pointer;
    }

    .sticky-controls {
        top: 60px;
    }
}

@media (min-width: 768px) {
    .principals-header {
        font-size: 20px;
    }
}

@media (min-width: 992px) {
    .grid-header {
        display: flex;
        flex-wrap: wrap;
    }

    .grid-header>div {
        width: 50% !important;
        box-sizing: border-box;
    }

    .modal-content img {
        max-height: 80vh;
    }
}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        width: calc(100% - 310px);
        margin-top: 82px;
    }

    .sticky-controls {
        top: 82px;
    }
}
</style>